import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=00abf6cd&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=00abf6cd&prod&scoped=true&lang=css"
import style1 from "./settings.vue?vue&type=style&index=1&id=00abf6cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abf6cd",
  null
  
)

export default component.exports